<template>
    <UICheckbox
        v-model="formDeliveryRequired"
        class="auction-set-delivery-required__checkbox"
        @update:model-value="handleSetDeliveryRequired"
    >
        Требуется доставка
    </UICheckbox>
</template>

<script lang="ts" setup>
    import { computed, ref } from 'vue';

    import { AuctionSetDeliveryRequiredForm } from '@/types/auction/auction-set-delivery-required-form.type.ts';

    import useAuctionRepository from '@/repositories/auction/useAuctionRepository.ts';

    import UICheckbox from '@/components/ui/UICheckbox/UICheckbox.vue';

    const { auctionId, isDeliveryRequired } = defineProps({
        auctionId: {
            type: Number,
            required: true,
        },
        isDeliveryRequired: {
            type: Boolean,
            default: false,
        },
    });

    const { setAuctionDeliveryRequired } = useAuctionRepository();

    const form = ref<AuctionSetDeliveryRequiredForm>({
        delivery_required: isDeliveryRequired ? 1 : 0,
    });

    const formDeliveryRequired = computed<boolean>({
        get: () => form.value.delivery_required === 1,
        set: (value) => {
            form.value.delivery_required = value ? 1 : 0;
        },
    });

    function handleSetDeliveryRequired(newValue: boolean): void {
        setAuctionDeliveryRequired(auctionId, form.value)
            .catch(() => {
                formDeliveryRequired.value = !newValue;
            });
    }
</script>

<style lang="scss" scoped>
    @use 'AuctionSetDeliveryRequired' as *;
</style>
